import { createIntlCache } from 'react-intl'

import type { I18nObject } from '@tribeplatform/react-components/i18n'
import { createI18n } from '@tribeplatform/react-components/i18n'

import { TranslatedDictionary } from './types.js'

const intlCache = createIntlCache()
const i18nStore: Record<string, I18nObject> = {}

/**
 * Catalog locales whose CLDR data must come from a different BCP 47 tag.
 *
 * `pt` is the European Portuguese catalog (POEditor has no `pt-pt` slot), but
 * CLDR's bare `pt` is Brazilian: it classifies 0 as `one` ("0 evento") and
 * groups digits as `1.234.567,89`. `pt-PT` gives Portugal's plural rules
 * ("0 eventos"), digit grouping (`1 234 567,89`) and date formats. The catalog
 * key, `availableLocales` value and `localeMapping` entry all stay `pt`.
 */
const INTL_LOCALE_OVERRIDES: Record<string, string> = {
  pt: 'pt-PT',
}

export const getIntlLocale = (locale: string): string =>
  INTL_LOCALE_OVERRIDES[locale.toLowerCase()] ?? locale

/**
 * If we decide to allow translation customization per community,
 * then we need to extend this method to create a separate
 * cache instance per network:
 *  getIntlCacheForNetwork(networkId: string) => IntlCache
 */
export const I18nStore = (locale: string, messages: TranslatedDictionary) => {
  return createI18n(
    {
      locale: getIntlLocale(locale),
      catalogLocale: locale,
      messages,
      onError: error => {
        logger.warn(error)
      },
    },
    intlCache,
  )
}

I18nStore.getOrCreate = (locale: string, messages: TranslatedDictionary) => {
  if (!i18nStore[locale]) {
    i18nStore[locale] = I18nStore(locale, messages)
  }

  return i18nStore[locale]
}
